module.exports = __webpack_public_path__ + "static/img/module_communicatie_counseling_header.8bb5380.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/module_communicatie_counseling_header.jpg
// module id = Jnt2
// module chunks = 0